import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

const NetAmountLineChart = ({ data = [] }) => {
    //console.log("Summary Graph Data:", data);
    const labels = data.map(d =>
        new Date(d.week_start).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short"
        })
    );

    const values = data.map(d => Number(d.net_outstanding_lakh));

    const chartData = {
        labels,
        datasets: [
            {
                label: "Net Outstanding (Lac)",
                data: values,
                borderColor: "#d32f2f",
                backgroundColor: "rgba(211,47,47,0.15)",
                tension: 0.4,
                fill: true,
                pointRadius: 3,
                pointHoverRadius: 6,
                datalabels: {
                    display: true,
                    // align: "top",
                    // anchor: "end",
                    offset: 6,
                    anchor: (ctx) => (ctx.dataIndex === 0 ? "start" : "end"),
                    align: (ctx) => (ctx.dataIndex === 0 ? "right" : "top"),
                    color: "#000",
                    font: {
                        weight: "bold",
                        size: 10
                    },

                    formatter: (value) => value.toFixed(2)
                }
            }

        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 30,                   // ✅ keeps distance from Y-axis
                right: 10,
                top: 10,
                bottom: 10
            }
        },
        plugins: {
            legend: {
                position: "top",
                align: "end",

            },
            tooltip: {
                mode: "index",
                intersect: false,
            },
            datalabels: {
                clamp: true,
                clip: false
            }
        },
        scales: {
            x: {
                ticks: { maxRotation: 90, minRotation: 90 },
                // offset: true
            },
            y: {
                beginAtZero: true ,
                title: { display: true, text: "Amount (Lac)" },
                ticks: {
                    callback: (value) => `${Number(value).toFixed(2)} L`  // ✅ 2 digits only
                  }
            }
        }
    };

    return (
        <div style={{ height: 260 }}>
            <Line data={chartData} options={options} />
        </div>
    );
};


export default NetAmountLineChart;
